<p-carousel [value]="attachments" verticalViewPortHeight="350px" [autoplayInterval]="autoplayInterval" [numVisible]="numVisible" [numScroll]="numScroll" [circular]="circular">
        <ng-template let-attachment pTemplate="item">
            <div class="p-grid">
                <div class="p-col-12 p-text-center">
                    <img [src]="attachment?.location" (click)="download(attachment?.location)" library="verona-layout" class="image-view" />
                </div>
            </div>
        </ng-template>
</p-carousel>
